"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupAllowed = exports.TokenTypeHint = exports.GrantType = void 0;
/** Type of grant used in token request */
var GrantType;
(function (GrantType) {
    GrantType["AuthorizationCode"] = "authorization_code";
    GrantType["Implicit"] = "implicit";
    GrantType["RefreshToken"] = "refresh_token";
    GrantType["Password"] = "password";
    GrantType["ClientCredentials"] = "client_credentials";
    GrantType["Internal"] = "internal";
    GrantType["DeviceCode"] = "urn:ietf:params:oauth:grant-type:device_code";
})(GrantType || (exports.GrantType = GrantType = {}));
/** Optional hint about the type of the submitted token. */
var TokenTypeHint;
(function (TokenTypeHint) {
    TokenTypeHint["AccessToken"] = "access_token";
    TokenTypeHint["RefreshToken"] = "refresh_token";
    TokenTypeHint["IdToken"] = "id_token";
    TokenTypeHint["Sid"] = "sid";
    TokenTypeHint["Sso"] = "sso";
})(TokenTypeHint || (exports.TokenTypeHint = TokenTypeHint = {}));
class GroupAllowed {
    constructor() {
        /** If true, all roles have to be included. If false, only 1 role from the list is needed */
        this.strictRoleValidation = false;
    }
}
exports.GroupAllowed = GroupAllowed;
